import FileUpload from './file-upload.element.js';

export default FileUpload;

FileUpload.define('wje-file-upload', FileUpload);
